import react, { createContext } from 'react';

const appContext = {
  user: [],
  auth: [],
  message: [],
  category: [],
  userType: [],
  spinner: false,
  timezone: []
};
export const Context = createContext(appContext);
